import React, { useState, useMemo } from 'react';
import { encodeBanyaData } from '../utils';
import { ClipboardIcon, CheckIcon } from '../icons/Icons';

export default function AlertModal({ banya, onYes, onNo }) {
  const [copied, setCopied] = useState(false);

  const shareUrl = useMemo(() => {
    const encoded = encodeBanyaData(banya);
    if (!encoded) return '';
    return `${window.location.origin}${window.location.pathname}#/share/${encoded}`;
  }, [banya]);

  const handleCopy = () => {
    navigator.clipboard.writeText(shareUrl).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    }).catch(() => {
      prompt('Скопируйте ссылку:', shareUrl);
    });
  };

  const rawLabel = [banya?.name].filter(Boolean);
  if (banya?.date) {
    try {
      rawLabel.push(new Date(banya.date).toLocaleDateString('ru-RU'));
    } catch {
      rawLabel.push(banya.date);
    }
  }
  const label = rawLabel.join(', ') + ' г.';

  return (
    <div className="alert-overlay" onClick={onNo}>
      <div className="alert-box" onClick={(e) => e.stopPropagation()}>
        <h3 className="alert-title">Данные будут удалены</h3>
        <p className="alert-sub">
          Скопируйте ссылку на расчёт<br/>и статистику бани<br/>«{label ? `${label}` : ''}»
        </p>
        {shareUrl && (
          <div className="alert-share-wrap">
            <input
              type="text"
              value={shareUrl}
              readOnly
              onClick={(e) => e.target.select()}
              className="alert-share-input"
            />
            <button onClick={handleCopy} className="alert-copy-icon">
              {copied ? <CheckIcon color="#34c759" /> : <ClipboardIcon color="#8e8e93" />}
            </button>
          </div>
        )}
        <div className="alert-buttons-column">
          <button className="btn-danger" onClick={onYes}>Удалить</button>
          <button className="btn-cancel" onClick={onNo}>Отмена</button>
        </div>
      </div>
    </div>
  );
}
